import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Deck from "@/pages/Deck";
import Presenter from "@/pages/Presenter";
import PrintView from "@/pages/PrintView";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/p/:slug" element={<Deck />} />
        <Route path="/p/:slug/presenter" element={<Presenter />} />
        <Route path="/p/:slug/print" element={<PrintView />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
